<template>
  <v-col class="mb-0 mt-0 pb-0 pt-0">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="dateLocal"
      transition="scale-transition"
      offset-y
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          class="date-field-label-top"
          v-model="dateText"
          v-bind:label="label"
          :placeholder="placeholder"
          :prepend-icon="prependIcon"
          persistent-hint
          persistent-placeholder
          readonly
          :append-icon="'mdi-close'"
          @click:append="onClear"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker v-model="dateLocal">
      </v-date-picker>
    </v-menu>
  </v-col>
</template>
<script>
export default {
  props: {
    label: String,
    placeholder: String,
    prependIcon: String,
    date: {
      type: String,
    },
  },
  data() {
    return {
      menu: false,
      dateLocal: this.date,
    };
  },
  computed: {
    dateText() {
      if (!this.dateLocal) return;

      return this.dateLocal;
    },
  },
  watch: {
    date(value) {
      this.dateLocal = value;
      this.$refs.menu.save(this.dateLocal);
    },
    dateLocal() {
      this.flag = true;
      this.onOk();
    },
  },
  methods: {
    onOk() {
      this.$refs.menu.save(this.dateLocal);
      this.$emit('changed', this.dateLocal);
    },
    onClear() {
      this.dateLocal = null;
      this.$emit('changed', this.dateLocal);
    },
  },
};
</script>

<style scoped>
.date-field-label-top >>> .v-label,
.date-field-label-top >>> .v-input__slot label {
  transform: translateY(-18px) scale(0.75) !important;
  max-width: 133%;
}
</style>
